/**
 * Free Gift Offer Manager - Free Bra Extender on ₹750+
 * Full event delegation architecture: guarantees 1-click claim, modal controls,
 * and spend threshold auto-removal work seamlessly across all dynamic AJAX cart updates.
 */

(function () {
  'use strict';

  let isProcessing = false;
  let isAutoRemoving = false;
  let activeEditMode = false;
  let activeCurrentVariantId = null;
  let activeCurrentLine = null;

  function getCartData() {
    return fetch('/cart.js', {
      headers: {
        'Accept': 'application/json'
      }
    }).then(res => {
      if (!res.ok) throw new Error('Failed to fetch cart.js');
      return res.json();
    });
  }

  function updateThemeCart(cart) {
    if (!cart || cart.status === 400 || typeof cart.item_count === 'undefined') {
      return;
    }

    // Halo Theme standard cart updater
    if (typeof window.halo !== 'undefined') {
      if (document.body.classList.contains('template-cart')) {
        if (typeof window.halo.updateCart === 'function') {
          window.halo.updateCart(cart);
          return;
        }
      } else {
        if (typeof window.halo.updateSidebarCart === 'function') {
          window.halo.updateSidebarCart(cart);
          return;
        }
      }
    }

    // Halo Theme sharedFunctions fallback
    if (window.sharedFunctions && typeof window.sharedFunctions.updateSidebarCart === 'function') {
      window.sharedFunctions.updateSidebarCart(cart);
      return;
    }

    // Custom event for listeners
    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
  }

  function closeModal() {
    const modals = document.querySelectorAll('.free-hoodie-modal-backdrop, #free-hoodie-quick-add-modal');
    modals.forEach(modal => {
      if (modal.contains(document.activeElement)) {
        document.activeElement.blur();
      }
      modal.classList.remove('is-open');
      modal.style.setProperty('display', 'none', 'important');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('free-hoodie-modal-open');
  }

  function cleanupModalIfClaimed() {
    const cards = document.querySelectorAll('[data-free-hoodie-card]');
    const isGiftClaimed = Array.from(cards).some(c => c.dataset.giftInCart === 'true');
    if (isGiftClaimed) {
      closeModal();
      document.querySelectorAll('body > #free-hoodie-quick-add-modal, body > .free-hoodie-modal-backdrop').forEach(el => {
        el.remove();
      });
    }
  }

  function relocateModalToBody() {
    const cards = document.querySelectorAll('[data-free-hoodie-card]');
    const isGiftClaimed = Array.from(cards).some(c => c.dataset.giftInCart === 'true');
    if (isGiftClaimed) {
      cleanupModalIfClaimed();
      return;
    }

    const modals = document.querySelectorAll('.free-hoodie-modal-backdrop, #free-hoodie-quick-add-modal');
    if (modals.length === 0) return;

    if (modals.length > 1) {
      for (let i = 0; i < modals.length - 1; i++) {
        modals[i].remove();
      }
    }

    const activeModal = document.querySelector('.free-hoodie-modal-backdrop, #free-hoodie-quick-add-modal');
    if (activeModal && activeModal.parentElement !== document.body) {
      document.body.appendChild(activeModal);
    }
  }

  function openModal(isEditMode = false, currentVariantId = null, currentLine = null) {
    const cards = document.querySelectorAll('[data-free-hoodie-card]');
    const isGiftClaimed = Array.from(cards).some(c => c.dataset.giftInCart === 'true');
    if (isGiftClaimed && !isEditMode) {
      cleanupModalIfClaimed();
      return;
    }

    relocateModalToBody();
    const modal = document.querySelector('#free-hoodie-quick-add-modal, .free-hoodie-modal-backdrop');
    if (!modal) return;

    activeEditMode = isEditMode;
    activeCurrentVariantId = currentVariantId;
    activeCurrentLine = currentLine;

    const titleAdd = modal.querySelector('.title-text-add');
    const titleEdit = modal.querySelector('.title-text-edit');
    const submitBtn = modal.querySelector('[data-modal-submit-btn]');

    if (isEditMode) {
      if (titleAdd) titleAdd.style.display = 'none';
      if (titleEdit) titleEdit.style.display = 'inline';
      if (submitBtn) {
        const btnText = submitBtn.querySelector('.btn-text');
        if (btnText) btnText.textContent = 'Update Free Bra Extender';
      }
    } else {
      if (titleAdd) titleAdd.style.display = 'inline';
      if (titleEdit) titleEdit.style.display = 'none';
      if (submitBtn) {
        const btnText = submitBtn.querySelector('.btn-text');
        if (btnText) btnText.textContent = 'Add Free Bra Extender to Cart';
      }
    }

    if (isEditMode && currentVariantId) {
      preselectVariantInModal(modal, currentVariantId);
    }

    modal.classList.add('is-open');
    modal.style.setProperty('display', 'flex', 'important');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('free-hoodie-modal-open');
  }

  function preselectVariantInModal(modal, targetVariantId) {
    const card = document.querySelector('[data-free-hoodie-card]');
    if (!card) return;

    const productJsonEl = card.querySelector('[data-free-hoodie-product-json]');
    if (!productJsonEl) return;

    let product = null;
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      return;
    }

    if (!product || !product.variants) return;

    const matched = product.variants.find(v => v.id === parseInt(targetVariantId, 10));
    if (!matched) return;

    matched.options.forEach((optVal, optIdx) => {
      const optionRow = modal.querySelector(`[data-option-index="${optIdx}"]`);
      if (optionRow) {
        const buttons = optionRow.querySelectorAll('.free-hoodie-swatch-btn, .free-hoodie-pill-btn');
        buttons.forEach(btn => {
          if (btn.dataset.value === optVal) {
            btn.click();
          }
        });
      }
    });
  }

  function getProductData() {
    const card = document.querySelector('[data-free-hoodie-card]');
    if (!card) return null;
    const jsonEl = card.querySelector('[data-free-hoodie-product-json]');
    if (!jsonEl) return null;
    try {
      return JSON.parse(jsonEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function handleOptionSelect(btn) {
    const row = btn.closest('.free-hoodie-modal-option-row');
    if (!row) return;

    const modal = btn.closest('.free-hoodie-modal-backdrop, #free-hoodie-quick-add-modal');
    if (!modal) return;

    const allButtonsInRow = row.querySelectorAll('.free-hoodie-swatch-btn, .free-hoodie-pill-btn');
    allButtonsInRow.forEach(b => b.classList.remove('is-selected'));
    btn.classList.add('is-selected');

    const selectedDisplay = row.querySelector('[data-option-selected-display]');
    if (selectedDisplay) {
      selectedDisplay.textContent = btn.dataset.value;
    }

    const imgEl = modal.querySelector('[data-modal-img]');
    if (btn.dataset.imageSrc && imgEl) {
      imgEl.src = btn.dataset.imageSrc;
    }

    updateModalVariantState(modal);
  }

  function updateModalVariantState(modal) {
    const product = getProductData();
    if (!modal || !product || !product.variants) return;

    const optionRows = modal.querySelectorAll('.free-hoodie-modal-option-row');
    const variantInput = modal.querySelector('[data-modal-variant-id]');
    const submitBtn = modal.querySelector('[data-modal-submit-btn]');
    const imgEl = modal.querySelector('[data-modal-img]');
    const stockIndicator = modal.querySelector('[data-modal-stock-indicator]');

    const selectedOptions = [];
    optionRows.forEach((row, idx) => {
      const selectedBtn = row.querySelector('.free-hoodie-swatch-btn.is-selected, .free-hoodie-pill-btn.is-selected');
      if (selectedBtn) {
        selectedOptions[idx] = selectedBtn.dataset.value;
      } else {
        const firstBtn = row.querySelector('.free-hoodie-swatch-btn, .free-hoodie-pill-btn');
        if (firstBtn) selectedOptions[idx] = firstBtn.dataset.value;
      }
    });

    const matchedVariant = product.variants.find(variant => {
      return variant.options.every((optVal, idx) => {
        return selectedOptions[idx] === undefined || optVal === selectedOptions[idx];
      });
    });

    if (matchedVariant && matchedVariant.featured_image && imgEl) {
      imgEl.src = matchedVariant.featured_image.src;
    }

    if (matchedVariant && variantInput) {
      variantInput.value = matchedVariant.id;
    }

    if (matchedVariant) {
      if (matchedVariant.available) {
        if (submitBtn) {
          submitBtn.disabled = false;
          const btnText = submitBtn.querySelector('.btn-text');
          if (btnText) {
            btnText.textContent = activeEditMode ? 'Update Free Bra Extender' : 'Add Free Bra Extender to Cart';
          }
        }
        if (stockIndicator) {
          stockIndicator.innerHTML = '<span class="stock-badge in-stock">✓ In Stock - Ready to Add</span>';
        }
      } else {
        if (submitBtn) {
          submitBtn.disabled = true;
          const btnText = submitBtn.querySelector('.btn-text');
          if (btnText) btnText.textContent = 'Sold Out';
        }
        if (stockIndicator) {
          stockIndicator.innerHTML = '<span class="stock-badge sold-out">✕ Sold Out</span>';
        }
      }
    }
  }

  // 1-Click Direct Claim Action
  function handleDirectAdd(btn) {
    if (isProcessing) return;

    const card = btn.closest('[data-free-hoodie-card]') || document.querySelector('[data-free-hoodie-card]');
    const variantId = btn.dataset.variantId || (card && card.dataset.giftFirstVariantId) || '67827983614231';
    if (!variantId) {
      console.error('No variant ID found for free gift');
      return;
    }

    isProcessing = true;
    btn.classList.add('is-loading');
    btn.disabled = true;

    const body = JSON.stringify({
      id: parseInt(variantId, 10),
      quantity: 1,
      properties: {
        '_is_free_gift': 'true',
        '_free_bra_extender': 'true'
      }
    });

    closeModal();

    fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
      .then(res => {
        if (!res.ok) throw new Error('Direct add failed with status: ' + res.status);
        return res.json();
      })
      .then(() => getCartData())
      .then(cart => {
        isProcessing = false;
        btn.classList.remove('is-loading');
        btn.disabled = false;
        closeModal();
        updateThemeCart(cart);
      })
      .catch(err => {
        console.error('Error adding free gift:', err);
        isProcessing = false;
        btn.classList.remove('is-loading');
        btn.disabled = false;
      });
  }

  // Remove Free Gift Action
  function handleRemoveGift(btn) {
    if (isProcessing) return;

    const card = btn.closest('[data-free-hoodie-card]') || document.querySelector('[data-free-hoodie-card]');
    const itemKey = btn.dataset.line || (card && card.dataset.giftItemKey) || (card && card.dataset.giftVariantId);
    if (!itemKey) return;

    isProcessing = true;
    btn.style.opacity = '0.5';

    const body = JSON.stringify({
      id: itemKey,
      quantity: 0
    });

    fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: body
    })
      .then(res => {
        if (!res.ok) throw new Error('Remove failed: ' + res.status);
        return res.json();
      })
      .then(() => getCartData())
      .then(cart => {
        isProcessing = false;
        updateThemeCart(cart);
      })
      .catch(err => {
        console.error('Error removing free gift:', err);
        isProcessing = false;
        btn.style.opacity = '1';
      });
  }

  // Modal Submit (Add or Edit)
  function handleModalSubmit(submitBtn) {
    if (isProcessing) return;

    const modal = submitBtn.closest('.free-hoodie-modal-backdrop, #free-hoodie-quick-add-modal');
    if (!modal) return;

    const variantInput = modal.querySelector('[data-modal-variant-id]');
    const variantId = variantInput ? parseInt(variantInput.value, 10) : null;
    if (!variantId) return;

    isProcessing = true;
    submitBtn.classList.add('is-loading');
    submitBtn.disabled = true;

    if (activeEditMode && activeCurrentVariantId) {
      const changeBody = JSON.stringify({
        id: activeCurrentLine || activeCurrentVariantId,
        quantity: 0
      });

      fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: changeBody
      })
        .then(res => {
          if (!res.ok) throw new Error('Failed to change line: ' + res.status);
          return res.json();
        })
        .then(() => {
          const addBody = JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: {
              '_is_free_gift': 'true',
              '_free_bra_extender': 'true'
            }
          });
          return fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: addBody
          });
        })
        .then(res => {
          if (!res.ok) throw new Error('Failed to add variant: ' + res.status);
          return res.json();
        })
        .then(() => getCartData())
        .then(cart => {
          isProcessing = false;
          submitBtn.classList.remove('is-loading');
          closeModal();
          updateThemeCart(cart);
        })
        .catch(err => {
          console.error('Error updating free gift:', err);
          isProcessing = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        });
    } else {
      const body = JSON.stringify({
        id: variantId,
        quantity: 1,
        properties: {
          '_is_free_gift': 'true',
          '_free_bra_extender': 'true'
        }
      });

      fetch(window.routes ? window.routes.cart_add_url : '/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      })
        .then(res => {
          if (!res.ok) throw new Error('Failed to add gift: ' + res.status);
          return res.json();
        })
        .then(() => getCartData())
        .then(cart => {
          isProcessing = false;
          submitBtn.classList.remove('is-loading');
          closeModal();
          updateThemeCart(cart);
        })
        .catch(err => {
          console.error('Error adding free gift:', err);
          isProcessing = false;
          submitBtn.classList.remove('is-loading');
          submitBtn.disabled = false;
        });
    }
  }

  // Spend Threshold Auto-removal
  function checkCartEligibility(cart) {
    if (!cart || isAutoRemoving || isProcessing) return;
    if (!cart.items || !Array.isArray(cart.items)) return;

    const cards = document.querySelectorAll('[data-free-hoodie-card]');
    if (!cards || cards.length === 0) return;

    const threshold = parseInt(cards[0].dataset.threshold || '75000', 10);
    const giftProductId = parseInt(cards[0].dataset.giftProductId || '15438537261335', 10);

    const giftItem = cart.items.find(item => {
      const isIdMatch = item.product_id === giftProductId || item.product_id === 15438537261335;
      const hasGiftProperty = item.properties && (
        item.properties._is_free_gift === 'true' ||
        item.properties._free_bra_extender === 'true' ||
        item.properties._free_hoodie_gift === 'true'
      );
      const isHandleMatch = item.handle && (item.handle.includes('bra-extender') || item.handle.includes('extender'));
      return isIdMatch || hasGiftProperty || isHandleMatch;
    });

    if (!giftItem) return;

    // Calculate eligible spend from non-gift cart items
    let eligibleSpend = 0;
    cart.items.forEach(item => {
      const isGift = (item.key === giftItem.key) ||
                     (item.product_id === giftProductId) ||
                     (item.product_id === 15438537261335) ||
                     (item.properties && (item.properties._is_free_gift === 'true' || item.properties._free_bra_extender === 'true' || item.properties._free_hoodie_gift === 'true')) ||
                     (item.handle && (item.handle.includes('bra-extender') || item.handle.includes('extender')));
      if (!isGift) {
        eligibleSpend += item.final_line_price;
      }
    });

    if (eligibleSpend < threshold) {
      isAutoRemoving = true;

      const body = JSON.stringify({
        id: giftItem.key,
        quantity: 0
      });

      fetch(window.routes ? window.routes.cart_change_url : '/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: body
      })
        .then(res => {
          if (!res.ok) throw new Error('Auto-remove HTTP error: ' + res.status);
          return res.json();
        })
        .then(updatedCart => {
          isAutoRemoving = false;
          if (updatedCart && typeof updatedCart.item_count !== 'undefined') {
            updateThemeCart(updatedCart);
          }
        })
        .catch(err => {
          console.error('Error auto-removing free gift:', err);
          isAutoRemoving = false;
        });
    }
  }

  // =========================================================================
  // GLOBAL EVENT DELEGATION
  // Handles clicks/taps on all dynamically created buttons without re-binding.
  // =========================================================================

  function handleInteraction(e) {
    // 1. Direct 1-Click "Claim Free Gift"
    const directBtn = e.target.closest('[data-direct-add-free-gift]');
    if (directBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleDirectAdd(directBtn);
      return;
    }

    // 2. Open Modal / Details
    const openTrigger = e.target.closest('[data-open-free-hoodie-modal]');
    if (openTrigger) {
      e.preventDefault();
      e.stopPropagation();
      const card = openTrigger.closest('[data-free-hoodie-card]') || document.querySelector('[data-free-hoodie-card]');
      const isEdit = openTrigger.dataset.editMode === 'true';
      const variantId = card ? card.dataset.giftVariantId : null;
      const line = card ? card.dataset.giftItemKey : null;
      openModal(isEdit, variantId, line);
      return;
    }

    // 3. Remove Free Gift (✕ button on claimed pill)
    const removeBtn = e.target.closest('[data-free-hoodie-remove-btn]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleRemoveGift(removeBtn);
      return;
    }

    // 4. Close Modal (✕ button, backdrop overlay, or [data-close-free-hoodie-modal])
    const closeTrigger = e.target.closest('[data-close-free-hoodie-modal], .free-hoodie-modal-close, .free-hoodie-modal-overlay');
    if (closeTrigger) {
      e.preventDefault();
      e.stopPropagation();
      closeModal();
      return;
    }

    // 5. Modal Option Buttons (Color swatches & size pills)
    const optionBtn = e.target.closest('.free-hoodie-swatch-btn, .free-hoodie-pill-btn');
    if (optionBtn && optionBtn.closest('.free-hoodie-modal-backdrop, #free-hoodie-quick-add-modal')) {
      e.preventDefault();
      e.stopPropagation();
      handleOptionSelect(optionBtn);
      return;
    }

    // 6. Modal Submit Button ("Add Free Bra Extender to Cart")
    const submitBtn = e.target.closest('[data-modal-submit-btn]');
    if (submitBtn) {
      e.preventDefault();
      e.stopPropagation();
      handleModalSubmit(submitBtn);
      return;
    }
  }

  // Bind delegated listeners
  document.addEventListener('click', handleInteraction);

  // Keydown Escape to close modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  });

  // Watch for cart update events
  document.addEventListener('cart-update', (event) => {
    cleanupModalIfClaimed();
    if (event && event.detail) {
      checkCartEligibility(event.detail);
    }
  });

  // Hook into jQuery AJAX completions to handle cart drawer updates
  if (typeof window.jQuery !== 'undefined') {
    window.jQuery(document).ajaxComplete(function (e, xhr, settings) {
      if (settings && settings.url) {
        if (settings.url.indexOf('ajax_side_cart') !== -1) {
          cleanupModalIfClaimed();
        } else if (
          (settings.url.indexOf('/cart/change') !== -1 || settings.url.indexOf('/cart/update') !== -1) &&
          !isAutoRemoving && !isProcessing
        ) {
          getCartData().then(cart => {
            cleanupModalIfClaimed();
            checkCartEligibility(cart);
          }).catch(() => {});
        }
      }
    });
  }

  // Initial cleanup on load
  document.addEventListener('DOMContentLoaded', () => {
    cleanupModalIfClaimed();
  });

  // Export globally
  window.initFreeHoodieCards = cleanupModalIfClaimed;
  window.openFreeHoodieModal = openModal;
  window.closeFreeHoodieModal = closeModal;
})();
